import React, { useEffect, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Checkbox, Grid, ListItemText } from "@mui/material";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Fade from "@mui/material/Fade";
import { json } from "react-router";
import Cookies from "universal-cookie";
import PopupForm from "../../Components/PopupForm";
import { useSelector } from "react-redux";
const cookies = new Cookies()


export default function FilterColumn(props) {
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [t] = useTranslation("common");

  const dataGridName = props.preferenceKey || window.location.href
  const storageKey = `${dataGridName + cookies.get('user_id')}`;

  const getStoredColumns = () => {
    if (props.useCookies) {
      return cookies.get(storageKey);
    }
    const val = localStorage.getItem(storageKey);
    return val ? JSON.parse(val) : null;
  };

  const setStoredColumns = (cols) => {
    if (props.useCookies) {
      cookies.set(storageKey, cols, { path: '/', maxAge: 31536000 }); // 1 year
    } else {
      localStorage.setItem(storageKey, JSON.stringify(cols));
    }
  };
  const handleClose = () => {
    props?.setOpen(false);

  };
  const setColumns = (columns) => {
    props.setColumns(columns)

  }
  const sameColumn = (a, b) => {
    if (a?.field && b?.field) return a.field === b.field;
    return a?.headerName === b?.headerName;
  };
  const handleChange = (column) => {
    let arr = [];
    props?.columns &&
      props?.columns?.map((itm) => {
        if (sameColumn(itm, column)) {
          arr.push({
            ...itm,
            hide: !itm?.hide,
          });
        } else {
          arr.push(itm);
        }
      });
    if (arr?.length > 0) {
      setColumns(arr);
    }
  };
  useEffect(() => {
    const localColumns = getStoredColumns();

    if (!localColumns) {
      setStoredColumns(props?.columns);
      setColumns(props?.columns);
    } else {
      let columnsArray = []
      if (props?.columns?.length) {
        props?.columns?.map((itm) => {
          const localColumn = localColumns?.length ? localColumns?.find(item => sameColumn(item, itm)) : null
          if (localColumn) {
            columnsArray?.push({
              ...itm,
              hide: localColumn?.hide
            })
          }
          else {
            columnsArray?.push(itm)
          }
        })
      }
      setStoredColumns(columnsArray);
      setColumns(columnsArray);
    }
  }, [])

  return (
    <PopupForm
      // open={props?.openForm}
      setOpen={props?.setOpen}
      open={props?.open}
      onClose={handleClose}
      title={t("GLOBAL.show_hide_columns")}
      isFullScreen={false}

      content={<Box className="Container-fluid position-relative" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} sx={{
          marginTop: '10px'
        }}>
          {props?.columns?.map((name, index) => {
            if (!props.showAllColumns && index >= props?.columns?.length - 1) {
              return null
            }
            return (
              <Grid key={name?.field || name?.headerName || index} xs={6} sm={6} md={6} lg={6} sx={{ padding: '0px' }}>
                <MenuItem
                  key={name?.field || name?.headerName}
                  value={name?.field || name?.headerName}
                  onClick={() => handleChange(name)}
                >
                  <Checkbox checked={!name?.hide} />
                  <ListItemText
                    primary={name?.headerName}
                    sx={{
                      "& .MuiTypography-root": {
                        fontFamily: "Cairo",
                      },
                    }}
                  />
                </MenuItem>
              </Grid>
            );
          })}


        </Grid>
      </Box>

      }
      footer={
        <>


          <Box sx={{ height: '100px', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>
            <Box display="flex" >

              <Button variant="outlined"
                // spacing={2}
                sx={{
                  width: '50% !important',
                  // flexGrow: 1, 
                  minWidth: '180px !important',
                  maxWidth: '180px !important',
                  margin: 1,
                  // backgroundColor:SearchButtonTheme?.clear_button_color,
                  color: maintheme?.secondary,
                  '&:hover': {
                    backgroundColor: `${maintheme?.secondary}88   !important`,
                  },
                  height: '35px',
                  fontFamily: 'Cairo-Bold'

                }}
                className="iconeFilterClear"
                color="secondary"
                onClick={() => {
                  const showAllColumns = props?.columns?.map(column => {
                    return {
                      ...column,
                      hide: false
                    }
                  })
                  setStoredColumns(showAllColumns)
                  setColumns(showAllColumns)
                  props?.setOpen(false)
                }}
              >
                {t('GLOBAL.Select_all_and_close')}
              </Button>
              <Button
                variant="contained"
                // spacing={2} 
                sx={{
                  // flexGrow: 1,
                  margin: 1,
                  width: '180px !important',
                  minWidth: '180px !important',
                  maxWidth: '180px !important',
                  backgroundColor: maintheme?.secondary,
                  '&:hover': {
                    backgroundColor: maintheme?.secondary + '88',
                  },
                  height: '35px',
                  fontFamily: 'Cairo-Bold'
                }}
                className="iconeFilterSearch"
                onClick={() => {
                  setStoredColumns(props?.columns)
                  props?.setOpen(false)
                }}
              >
                {t('GLOBAL.Save_and_close')}
              </Button>
            </Box>
          </Box>

        </>

      }
    />
  );
}
